import { render, staticRenderFns } from "./BrokerHome.vue?vue&type=template&id=13f02313&"
import script from "./BrokerHome.vue?vue&type=script&lang=ts&"
export * from "./BrokerHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports